import React, { forwardRef, useState } from 'react';
import { Box, Button, Collapse } from '@mui/material';
import {
  CRUD_COMPONENT_TYPE,
  CRUDComponent,
  Label,
  SubSection,
  useDataProvider,
  useUserAccess,
} from '@ui-framework/index';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { useFormContext } from 'react-hook-form';
import PageSection from '../../../PageSection';
import {
  jobNumber,
  appointmentDate,
  serviceProvider,
  servicePerformed,
  serviceJobStatus,
  serviceCompletionDate,
} from './accessorFunctions';
import listSA from './schemas/listSA.json';
import listSP from './schemas/listSP.json';
import CloseButton from '../CloseButton';

const JobsInProcess = forwardRef((props, ref) => {
  const { getValues } = useFormContext();
  const serviceJobId = getValues('id');
  const userAccess = useUserAccess();

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const dataProvider = useDataProvider(provider);
  const listSchema =
    userAccess.isSA() || userAccess.isAdmin() ? listSA : listSP;
  const [open, setOpen] = useState(true);

  const listApiUrl = `${dataProvider.getApiUrl()}/sxcl/v1/service-jobs/${serviceJobId}/service-history`;

  const listProps = {
    columnPrimaryId: 'id',
    storeName: 'JobsInProcess',
    dataProvider,
    schema: listSchema,
    initialState: {
      showColumnFilters: false,
    },
    downloadApiUrl: null,
    listApiUrl,
    accessorFunctions: {
      jobNumber,
      appointmentDate,
      serviceProvider,
      servicePerformed,
      serviceJobStatus,
      serviceCompletionDate,
    },
    sortBy: 'appointmentDate',
    SortOrder: 'DESC',
  };

  const handleToggle = e => {
    e.preventDefault();
    setOpen(prev => !prev);
  };

  return (
    <Box ref={ref}>
      {!open && (
        <Button onClick={handleToggle} variant="text">
          View Jobs In Process
        </Button>
      )}
      <Collapse in={open}>
        <SubSection>
          <Grid2 container>
            <Grid2 xs={8}>
              <Label>Jobs in Process</Label>
            </Grid2>
            <Grid2 xs={4} textAlign="right">
              <CloseButton onClose={() => setOpen(false)} />
            </Grid2>
          </Grid2>

          <Box mt={2}>
            <PageSection containerProps={{ sx: { mt: -2 } }}>
              <Box>
                <CRUDComponent
                  type={CRUD_COMPONENT_TYPE.SEMI_ADVANCED_LIST}
                  listProps={listProps}
                />
              </Box>
            </PageSection>
          </Box>
        </SubSection>
      </Collapse>
    </Box>
  );
});

export default JobsInProcess;
